<template>
    <div
            class="modal fade"
            id="sys_record_model"
            tabindex="-1"
            role="dialog"
            aria-labelledby="myModalLabel"
            aria-hidden="true"
    >
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                    <h4 class="modal-title" id="myModalLabel">电表查表记录</h4>
                </div>
                <!-- modal-body-->
                <div class="modal-body">
                    <table id="atptable" class="table table-hover table-striped">
                        <thead>
                        <tr>
                            <th>电表编号</th>
                            <th>查表日期</th>
                            <th>电表读数</th>
                            <th>电表照片</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(item,index) in ammeterInfo" :key="index">
                            <td>{{item.ammeter_numbering}}</td>
                            <td>{{item.create_datetime}}</td>
                            <td>{{item.amount}}</td>
                            <td>
                                <img
                                        :src="item.picture_ammeter"
                                        @click="enlarge(item.picture_ammeter)"
                                        alt
                                        style="width:100px;height:100px;"
                                />
                            </td>
                        </tr>
                        <tr v-if="ammeterInfo.length>0"></tr>
                        <tr class="no-records-found" v-else>
                            <td colspan="8">没有找到匹配的记录</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <!-- modal-footer -->
                <div class="modal-footer">
                    <button type="button" data-dismiss="modal" class="btn btn-default">关闭</button>
                    <!-- <button type="button" data-dismiss="modal" class="btn btn-primary"></button> -->
                </div>
            </div>
        </div>
        <img class="imgLayer" v-show="imgShow" :src="imgSrc" alt @click="narrow"/>
    </div>
</template>
<script>
  export default {
    data () {
      return {
        ammeterInfo: [],
        imgSrc: '', // 被放大图片的路径
        imgShow: false
      }
    },
    props: ['msgAmmeterid'],
    mounted () {},
    methods: {
      // 获取查表记录
      getData: function () {
        var self = this
        self.ammeterInfo = []
        self.global.axiosGet(
          self,
          'ammeter/' + self.msgAmmeterid + '/records/',
          // "ammeter/guid7292363B-E665-4A6E-83B2-5E7F3FC198CD/records/",
          function (resp) {
            // console.log(res);
            for (var m = 0; m < resp.length; m++) {
              resp[m].picture_ammeter = self.global.ossHost + resp[m].photo_path
              resp[m].ammeter_numbering = self.$parent.ammeternumber
            }
            self.ammeterInfo = resp
          },
          function () {
            alert('操作失败,请稍后重试')
          }
        )
      },
      // 图片放大
      enlarge: function (src) {
        console.log(src)
        var self = this
        self.imgShow = true
        self.imgSrc = src
      },
      // 图片缩小
      narrow: function () {
        var self = this
        self.imgShow = false
      }
    }
  }
</script>
<style scoped>
    .imgLayer {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
        z-index: 999;
        max-width: 100%;
        max-height: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/views/ammeter/ammeterrecord.vue